// Shown for a failed intake whose stored error is internal text. Matches the
// backend's INTAKE_PROCESSING_FAILED_MESSAGE (referral_parsing.py).
export const INTAKE_PROCESSING_FAILED_MESSAGE =
  "This referral couldn't be processed. Retry the intake.";

// Internal error text an intake row can hold, which users must not see: job and
// workflow failures, RogerDocs and network errors, timeouts, exception classes.
const RAW_ERROR_PATTERNS = [
  /^Job \S+ /,
  /^Failed to trigger workflow:/,
  /Cannot continue workflow/,
  /^[A-Z]\w*(Error|Exception)\b/,
  /RogerDoc/,
  /^Network error/,
  /request failed: \d{3}/i,
  /timeout/i,
];

/** The failure text a user may read for an intake, or null when there is none. */
export function intakeErrorForDisplay(
  processingErrors: string | null | undefined
): string | null {
  const text = processingErrors?.trim();
  if (!text) return null;
  return RAW_ERROR_PATTERNS.some(pattern => pattern.test(text))
    ? INTAKE_PROCESSING_FAILED_MESSAGE
    : text;
}
